export default {
    name          : 'banner',
    _banner       : null,
    _defaultSpeed : 4,
    init() {
        this._banners = document.querySelectorAll('[data-banner]');
        if (!this._banners) {
            return;
        }

        for (const banner of this._banners) {
            banner.closest(".js-banner-wrapper").style = `padding-top: ${banner.clientHeight}px;`;

            window.addEventListener('scroll', e => {
                const speed = banner.getAttribute('data-banner');
                const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                banner.style = `transform: translate3d(0px, -${scrollTop / (speed ? speed : 4)}px, 0px);`;
            });


            let swiper = document.querySelector(".swiper");

            // ignore if no swiper element to avoid errors
            if (! swiper) {
                continue;
            }

            swiper.style.height = banner.clientHeight+"px";
        }
    }
}